<template>
  <div class="gf_btn-preview" :style="styleButton.button" @mouseover="onHoverButton" @mouseleave="onLeaveButton">
    <template v-if="IS_SETTING_ICON_IN_BUTTON">
      <span v-if="isUseVarianText" class="gf_btn-preview__text">{{ titleButton }}</span>
      <span
        v-else-if="isUseVarianIcon"
        class="gf_btn-preview__icon"
        :style="styleButton.icon"
        v-html="displayIcon"></span>
      <template v-else>
        <span
          v-show="positionIconBefore"
          class="gf_btn-preview__icon gf_btn-preview__icon--left"
          :class="`gf_btn-preview__icon--left-${typeButton}`"
          :style="styleButton.icon"
          v-html="displayIcon"></span>
        <span class="gf_btn-preview__text">{{ titleButton }}</span>
        <span
          v-show="positionIconAfter"
          class="gf_btn-preview__icon gf_btn-preview__icon--right"
          :class="`gf_btn-preview__icon--right-${typeButton}`"
          :style="styleButton.icon"
          v-html="displayIcon"></span>
      </template>
    </template>
    <template v-else>
      <span class="gf_btn-preview__text">{{ titleButton }}</span>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  ICON_BUTTON,
  TEXT_BUTTON,
  BEFORE_ICON_POSITION,
  AFTER_ICON_POSITION,
  IS_SETTING_ICON_IN_BUTTON,
} from '@modules/editor-sidebar';

import HELPER from '@/app/utils/HELPER';

export default defineComponent({
  name: 'ButtonPreviewItem',
  props: {
    styleButton: {
      type: Object,
      default: () => ({}),
    },
    button: {
      type: Object,
      default: () => ({}),
    },
    typeButton: {
      type: String,
      default: '',
    },
    titleButton: {
      type: String,
      default: 'Custom Button',
    },
  },
  data() {
    return {
      ICON_BUTTON,
      TEXT_BUTTON,
      BEFORE_ICON_POSITION,
      AFTER_ICON_POSITION,
      IS_SETTING_ICON_IN_BUTTON,
    };
  },
  computed: {
    isUseVarianIcon() {
      return this.button.value.buttonStyle === this.ICON_BUTTON;
    },
    isUseVarianText() {
      return this.button.value.buttonStyle === this.TEXT_BUTTON;
    },
    positionIconBefore() {
      return this.button.value.iconPosition === this.BEFORE_ICON_POSITION;
    },
    positionIconAfter() {
      return this.button.value.iconPosition === this.AFTER_ICON_POSITION;
    },
    displayIcon() {
      return HELPER.base64UrlDecode(this.button.value.icon);
    },
  },
  updated() {},
  methods: {
    onHoverButton() {
      this.$emit('onHoverButton', this.typeButton);
    },
    onLeaveButton() {
      this.$emit('onLeaveButton', this.typeButton);
    },
  },
});
</script>

<style scoped lang="scss">
.lbl {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  padding-bottom: 8px;
}

.gf_btn-preview {
  width: max-content;
  display: flex;
  align-items: center;
  background-image: url('/editor/static/icons/transparent-color.svg');
  background-size: cover;
  cursor: pointer;
  line-height: 1;
  &__icon {
    &--left {
      &-button-large {
        margin-right: 16px;
      }
      &-button-medium {
        margin-right: 8px;
      }
      &-button-small {
        margin-right: 4px;
      }
    }
    &--right {
      &-button-large {
        margin-left: 16px;
      }
      &-button-medium {
        margin-left: 8px;
      }
      &-button-small {
        margin-left: 4px;
      }
    }
  }
}
</style>
